/* eslint-disable hubspot-dev/no-private-classes */
export const protectedDocs = {
  'Developers:AppObjectsDocs:PrivateBeta': {
    'en-us': {
      'guides/apps': ['app-objects/overview', 'app-objects/quickstart-guide-to-app-objects', 'app-objects/reference']
    }
  }
};